import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import EquipaPage from "./pages/EquipaPage";
import InscricoesPage from "./pages/InscricoesPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import PerfilPage from "./pages/PerfilPage";
import RenovacaoPage from "./pages/RenovacaoPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import { Toaster } from "./components/ui/toaster";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-white text-stone-900">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/equipa" element={<EquipaPage />} />
          <Route path="/inscricoes" element={<InscricoesPage />} />
          <Route path="/area-socio/login" element={<LoginPage />} />
          <Route path="/area-socio/registar" element={<RegisterPage />} />
          <Route path="/area-socio/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/area-socio/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/area-socio/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/area-socio/perfil"
            element={
              <ProtectedRoute>
                <PerfilPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/area-socio/renovar"
            element={
              <ProtectedRoute>
                <RenovacaoPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
